import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AdminLayout from './components/AdminLayout';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Distributors from './components/Distributors';
import Settings from './components/Settings';
import CMS from './components/CMS';
import Liters from './components/Liters';
import Brands from './components/Brands';
import Banners from './components/Banners';
import Products from './components/Products';
import Drivers from './components/Drivers';
import Orders from './components/Orders';
import Payments from './components/Payments';
import Reports from './components/Reports';
import Notifications from './components/Notifications';
import Users from './components/Users';
import './App.css';

const PrivateRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <AdminLayout />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="users" element={<Users />} />
              <Route path="distributors" element={<Distributors />} />
              <Route path="settings" element={<Settings />} />
              <Route path="cms" element={<CMS />} />
              <Route path="liters" element={<Liters />} />
              <Route path="brands" element={<Brands />} />
              <Route path="banners" element={<Banners />} />
              <Route path="products" element={<Products />} />
              <Route path="drivers" element={<Drivers />} />
              <Route path="orders" element={<Orders />} />
              <Route path="payments" element={<Payments />} />
              <Route path="reports" element={<Reports />} />
              <Route path="notifications" element={<Notifications />} />
            </Route>
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
